import React from "react";

function Welcome({ onBegin }) {

  return (
    <div className="welcome-container">
      <header className="welcome-header">
        <h1>Care Chat</h1>
        <div className="welcome-tagline">A gentle way to explore your healthcare values with family</div>
      </header>
      
      <section className="welcome-content">
        <div className="purpose-section">
          <h2>Purpose</h2>
          <p>
            This conversation tool is designed to help couples and families discuss hypothetical 
            medical scenarios that could arise in emergency situations. It is not intended for 
            use in actual medical decision-making.
          </p>
          <p>
            By exploring hypothetical scenarios through yes/no questions, you can start meaningful 
            conversations about values and preferences. The resulting summary is for reference only.
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h2>Legal Disclaimers</h2>
          <ul>
            <li>
              <strong>No Legal Effect:</strong> This tool produces documents with NO LEGAL EFFECT. It is not an advance 
              directive, living will, POLST form, or any other legally recognized document.
            </li>
            <li>
              <strong>No Medical Advice:</strong> This tool does not provide medical advice. All medical decisions 
              should be made in consultation with qualified healthcare providers.
            </li>
            <li>
              <strong>No Substitution:</strong> The output of this tool does not substitute for proper advance care planning, 
              which should be done with legal and medical professionals under state-specific guidelines.
            </li>
            <li>
              <strong>No Liability:</strong> The creators and operators of this tool accept no liability for medical decisions 
              made with or without reference to any materials generated by this tool.
            </li>
            <li>
              <strong>In Emergencies:</strong> Medical professionals follow established protocols and state laws
              for emergency consent, regardless of preferences recorded here.
            </li>
            <li>
              <strong>No Data Stored:</strong> Your medical preferences and answers are never recorded, stored, or transmitted — they remain on your device only. We use anonymous analytics (Google Analytics) to understand how users navigate the tool and improve the experience. No medical answers or preferences are included in analytics data.
            </li>
          </ul>
        </div>
        
        <div className="trust-indicators">
          <div className="trust-item">🔒 Your privacy is protected</div>
          <div className="trust-item">👨‍⚕️ Medical professionals were consulted during development</div>
          <div className="trust-item">💬 For conversation, not legal advice</div>
        </div>
        
      </section>
      
      <div className="welcome-action">
        <button 
          className="begin-button" 
          onClick={onBegin}
        >
          I Understand - Begin Conversation Tool
        </button>
      </div>
    </div>
  );
}

export default Welcome;